<!--
    描述：权限管理页面
    时间：2020-04-22
    Created by ws
-->
<template>
    <div class="">
        这里是 权限管理页面
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    methods: {

    }
}
</script>

<style scoped lang="less">
</style>
